module.exports = __webpack_public_path__ + "static/media/19ESCAP6.204e2886.jpg";